import React, { useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import ArrowDropDownRoundedIcon from "@material-ui/icons/ArrowDropDownRounded";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import VerifiedUserOutlinedIcon from "@material-ui/icons/VerifiedUserOutlined";
import { AccountCircle } from "@material-ui/icons";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import SvgBadge from "../../components/common/leaderBoardCommon/svg/UpdatedBadge";
import RequestIcon from "../../icons/Request.svg";
import CertificateIcon from "../../icons/certificate.png";
import Feedback from "../../icons/feedback.svg";
import { TOPBAR_LOGO } from "../../components/common/branding";

import {
  AppBar,
  Button,
  Badge,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  makeStyles,
  Menu,
  MenuItem,
  Avatar,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import NotificationsIcon from "@material-ui/icons/NotificationsOutlined";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router";
import { connect, useSelector } from "react-redux";
import { getRequestCount, getSignOut } from "../../helpers/api/api";
import Dialog from "@material-ui/core/Dialog";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { callPatchNotificationView } from "../../reducers/notifications/notificationView";
import Logocomp from "./compo-logo";
import badgeIcon from "../../images/user-badge.svg";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const messages = {
  header: "",
  signin: "SignIn",
  signout: "Sign out",
  profile: "My Profile",
  getHelp: "Get help",
  notification: "Notifications",
  message: "Messages",
  licenses: "License",
};

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.header.text,
    "& #darktheme .badge": {
      backgroundColor: "#fff",
    },
  },
  avatar: {
    width: 60,
    height: 60,
  },
  badge: {
    maxWidth: "20px",
    display: "block",
  },
  menu: {
    top: "42px !important",
    left: "36px !important",
    marginLeft: "35px",
    "& .MuiListItem-root.Mui-selected": {
      backgroundColor: theme.UpdateTheme.button_color,
      color: theme.UpdateTheme.text_color,
    },
  },

  notchedOutline: {
    borderRadius: "42px",
  },
  customBadge: {
    backgroundColor: "red",
    color: theme.palette.leftBar.text,
  },
  appBar: {
    position: "relative",
    backgroundColor: theme.palette.leftBar.active,
    color: theme.palette.header.text,
  },
  logopaper: {
    marginLeft: "-24px",
    padding: "0",
    borderRadius: "0px",
    width: "256px",
    textAlign: "center",
    zIndex: "1201",
    border: "none",
  },
  img: {
    maxWidth: "220px",
    height: "auto",
    padding: "12px 0px 1px 0px",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },

  fixItTrans: {
    backgroundColor: "transparent",
    boxShadow: "none",
  },

  fixItWhite: {
    backgroundColor: "#ffffff",
    boxShadow: "3px 0px 20px #00000014",
  },

  darkbtn: {
    backgroundColor: "#464646",
    color: "#ffffff",
    border: "1px solid #464646",
    "&:hover": {
      backgroundColor: "#464646",
    },
  },
  lightbtn: {
    backgroundColor: "#ffffff",
    color: "#464646",
    border: "1px solid #464646",
    "&:hover": {
      backgroundColor: "#ffffff",
    },
  },

  mSearch: {
    width: "100%",
  },
  main: {
    color: "#ffffff",
  },
  topParent: {
    width: "calc(100% - 250px)",
    alignSelf: "flex-end",
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  requests: {
    display: "inline-flex",
    width: "39px",
    height: "26px",
    color: "#FFC62D",
    fontSize: "20px",
    backgroundColor: "#060236",
    borderRadius: "5px",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "10px",
  },
  badgeAlign: {
    display: "flex",
  },
}));

const not_barstyle = {
  fontSize: "10px",
  color: "#fff",
  background: "red",
  height: "22px",
  width: "22px",
  borderRadius: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  top: "-10px",
  left: "10px",
};

const TopBar = (props) => {
  const {
    auth,
    callPatchNotificationView,
    is_approved,
    badgeData,
    loadUserData,
    className,
    userDetail,
    match,
    session,
    onMobileNavOpen,
    ...rest
  } = props;
  const classes = useStyles();
  let history = useHistory();
  let location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [profilePic, setProfilePic] = useState(null);
  const [notificationcount, setNotificationcount] = useState("");
  const [requestsCount, setRequestsCount] = useState(0);
  const isThemeDark = /true/i.test(localStorage.getItem("isThemeDark"));

  const handleMenu = (event) => {
    getRequestCount().then((res) => {
      setRequestsCount(res.result);
    });
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    if (session.profile && session.unread_notification) {
      setProfilePic(session.profile.file_name);
      setNotificationcount(session.unread_notification);
    }
  }, [session]);

  let UserName = session?.fullname;
  let roleIs = session?.membership?.role?.id;
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogg = async () => {
    await getSignOut();
  };

  const signout = () => {    
    handleLogg();
    localStorage.removeItem("token");
    localStorage.setItem(
      "lastActiveModule",
      window.location.pathname.split("/")[1]
    );
    localStorage.removeItem("decryptKey");
    window.history.replaceState(null, "", "/");
    window.location.href = "/";
  };
  const [open, setOpen] = React.useState(false);
  const handleSearchClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    if (session?.profile) {
      setProfilePic(session?.profile?.file_name);
    }
  }, []);

  const [headBg, setHeadBg] = useState(false);

  window.addEventListener("scroll", function () {
    let top = this.scrollY;
    if (top > 25) {
      setHeadBg(true);
    }
    if (top < 25) {
      setHeadBg(false);
    }
  });

  const changeAttr = () => {
    localStorage.setItem("isThemeDark", !isThemeDark);
    window.location.reload();
  };

  const handleNotiClick = () => {
    history.push("/notifications");
    const formData = {
      is_viewed: true,
    };
    callPatchNotificationView(formData)
      .then((res) => {})
      .catch((error) => {});
  };

  const getThemeText = () => {
    return `${isThemeDark ? "Light Theme" : "Dark Theme"}`;
  };

  return (
    <AppBar
      {...rest}
      style={{ color: "#000" }}
      id="fixhead"
      className={headBg ? classes.fixItWhite : classes.fixItTrans}
    >
      {UserName && (
        <Toolbar className={classes.topParent}>
          <Box flexGrow={1} className={classes.main} />
          {TOPBAR_LOGO && <Logocomp logoHeight={"50px"} />}
          <Hidden mdDown>
            <Button
              className={!isThemeDark ? classes.lightbtn : classes.darkbtn}
              type="button"
              onClick={changeAttr}
              style={{ display: "none" }}
            >
              {getThemeText()}
            </Button>
            {session?.profile?.permissions && (
              <IconButton color="inherit" onClick={handleNotiClick}>
                <Badge classes={{ badge: classes.customBadge }} color="#FFC62D">
                  <NotificationsIcon />
                  {notificationcount ? (
                    <span id="notif_counter" style={not_barstyle}>
                      {notificationcount}
                    </span>
                  ) : null}
                </Badge>
              </IconButton>
            )}
            {session?.profile?.permissions && roleIs === 4 && (
              <RouterLink
                to="/leaderboard"
                className={`${classes.badgelink} badgelinkdark`}
              >
                <SvgBadge
                  height={30}
                  width={30}
                  style={{ color: `${session?.user_badge?.badge_color}` }}
                  image={
                    session?.user_badge?.badge_image_fk?.file
                      ? session?.user_badge?.badge_image_fk?.file
                      : badgeIcon
                  }
                  top="42%"
                />
              </RouterLink>
            )}
            {[1, 2, 3].includes(roleIs) ? (
              <RouterLink
                to="/leaderboard"
                className={`${classes.badgelink} badgelinkdark ${classes.badgeAlign}`}
              >
                <img src={badgeIcon} alt="icon" height={30} width={30} />
              </RouterLink>
            ) : (
              ""
            )}
            <h6
              style={{
                margin: "15px 0px",
                padding: "5px 5px 5px 10px",
                fontSize: "14px",
                fontWeight: "400",
              }}
            >
              {UserName}
            </h6>

            <IconButton
              style={{ marginRight: "-19px", backgroundColor: "transparent" }}
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              {profilePic ? (
                <>
                  <Avatar
                    style={{ height: "24px", width: "24px" }}
                    alt={profilePic}
                    src={profilePic}
                  />
                  <ArrowDropDownRoundedIcon />
                </>
              ) : (
                <>
                  <AccountCircle />
                  <ArrowDropDownRoundedIcon />
                </>
              )}
            </IconButton>
          </Hidden>
          <Hidden lgUp>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              {profilePic ? (
                <>
                  <Avatar
                    style={{ height: "24px", width: "24px" }}
                    alt={profilePic}
                    src={profilePic}
                  />
                  <ArrowDropDownRoundedIcon />
                </>
              ) : (
                <>
                  <AccountCircle />
                  <ArrowDropDownRoundedIcon />
                </>
              )}
            </IconButton>
            <IconButton color="inherit" onClick={onMobileNavOpen}>
              <MenuIcon />
            </IconButton>
          </Hidden>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            className={classes.menu}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            keepMounted
            transformOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            open={openMenu}
            onClose={handleClose}
          >
            {session?.profile?.permissions && (
              <MenuItem
                selected={location.pathname === "/myprofile"}
                onClick={() => {
                  history.push("/myprofile");
                  setAnchorEl(null);
                }}
              >
                <IconButton
                  aria-label="account of current user"
                  aria-haspopup="true"
                  color="inherit"
                >
                  {" "}
                  <AccountCircle />
                </IconButton>
                {messages.profile}
              </MenuItem>
            )}
            <MenuItem
              selected={location.pathname === "/support"}
              onClick={() => {
                history.push("/support");
                setAnchorEl(null);
              }}
            >
              {" "}
              <IconButton color="inherit">
                <ContactSupportIcon />
              </IconButton>{" "}
              Support
            </MenuItem>
            {roleIs !== 4 && (
              <MenuItem
                selected={location.pathname === "/requests"}
                onClick={() => {
                  history.push("/requests");
                  setAnchorEl(null);
                }}
              >
                <IconButton color="inherit">
                  <img src={RequestIcon} alt="Request" />
                </IconButton>
                Requests{" "}
                <span className={classes.requests}>{requestsCount}</span>
              </MenuItem>
            )}
            {roleIs === 4 && (
              <MenuItem
                selected={location.pathname === "/certificate"}
                onClick={() => {
                  history.push("/certificate");
                  setAnchorEl(null);
                }}
              >
                <IconButton color="inherit">
                  <img src={CertificateIcon} width="20" alt="Certificate" />
                </IconButton>
                Certificate
              </MenuItem>
            )}

            <MenuItem
              selected={location.pathname === "/feedback"}
              onClick={() => {
                history.push("/feedback");
                setAnchorEl(null);
              }}
            >
              <IconButton color="inherit">
                <img src={Feedback} width="20" alt="Certificate" />
              </IconButton>
              Feedback
            </MenuItem>
            {roleIs === 1 && (
              <MenuItem
                selected={location.pathname === "/licenses"}
                onClick={() => {
                  history.push("/licenses");
                  setAnchorEl(null);
                }}
              >
                {" "}
                <IconButton color="inherit">
                  <VerifiedUserOutlinedIcon />
                </IconButton>{" "}
                {messages.licenses}
              </MenuItem>
            )}
            <MenuItem onClick={signout}>
              {" "}
              <IconButton
                aria-label="account of current user"
                aria-haspopup="true"
                color="inherit"
              >
                {" "}
                <ExitToAppIcon />
              </IconButton>{" "}
              {messages.signout}{" "}
            </MenuItem>
          </Menu>
          <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
          >
            <AppBar className={classes.appBar}>
              <Toolbar>
                <IconButton
                  edge="right"
                  color="inherit"
                  onClick={handleSearchClose}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <List>
              <ListItem button></ListItem>
              <Divider />
              <ListItem button>
                <ListItemText
                  primary="Default text search"
                  secondary="Search results"
                />
              </ListItem>
            </List>
          </Dialog>
        </Toolbar>
      )}
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
};

const mapState = (state) => {
  return {
    session: state.session,
    userDetail: state.userProfile.userDetail,
  };
};

const mapDispatch = (dispatch) => {
  return {
    callPatchNotificationView: (body) =>
      dispatch(callPatchNotificationView(body)),
  };
};
export default connect(mapState, mapDispatch)(TopBar);
